import { firestoreAction } from 'vuexfire'
import { db } from '@/firebase/db'

const state = {
  inspect: [],
}

const getters = {
  list(state){
    return state.inspect
  },
}

const mutations = {}

const actions = {
  inspect: firestoreAction(({ bindFirestoreRef }, id) => {
    return bindFirestoreRef('inspect', db.collection('containerorders').where('projectid', '==', id).orderBy("createddate", "desc"))
  }),

  add: firestoreAction(({context} ,order) => {
    console.log(context)
    return db.collection('containerorders').add(order)
  }),
  
  update: firestoreAction(({context}, container) => {
    console.log(context)
    return db.collection('containerorders').doc(container.id).update(container)
  })
}


export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}